<div class="video-container">
  <div class="videoWrapper">
    <!-- Copy & Pasted from YouTube -->
    <iframe width="560" height="349" [src]="videoURL" frameborder="0" allowfullscreen></iframe>
  </div>
</div>
